export function createBootScene({ level, selectedPlayableIcon }) {
  return {
    key: 'RangerBootScene',

    create() {
      this.scene.start('RangerPreloadScene', {
        level,
        selectedPlayableIcon,
      });
    },
  };
}
